export const defaultForms = {
  universalLogin: {
    form: {
      formCode: 'universalLogin',
      formTitle: 'Login Universal',
      requireSession: false,
      functions: [],
    },
    states: [
      {
        name: 'credentialInput',
        description: 'Ingreso de credenciales',
      },
      {
        name: 'complementaryInput',
        description: 'Ingreso de información complementaria',
      },
      {
        name: 'sessionOpenning',
        description: 'Apertura de sesión',
      },
    ],
    transitions: [
      {
        name: 'validateCredential',
        description: 'Validar Credenciales',
        source: 'credentialInput',
        destination: 'complementaryInput',
      },
      {
        name: 'openSessionFromCredentials',
        description: 'Abrir sesión desde credenciales',
        source: 'credentialInput',
        destination: 'sessionOpenning',
      },
      {
        name: 'enterComplementaryData',
        description: 'Ingreso de datos complementarios',
        source: 'credentialInput',
        destination: 'complementaryInput',
      },
      {
        name: 'openSessionFromExtra',
        description: 'Abrir sesión desde datos extra',
        source: 'complementaryInput',
        destination: 'sessionOpenning',
      },
    ],
    sections: [
      {
        sectionCode: 'credentialsInfo',
        sectionTitle: 'Información de credenciales',
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        subsections: [
          {
            subsectionCode: 'credentials',
            subsectionTitle: 'Credenciales',
            visibleStates: [
              'credentialInput',
              'complementaryInput',
              'sessionOpenning',
            ],
            elements: [
              {
                elementTypeName: 'FIELD',
                elementCode: 'userName',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'userPassword',
              },
            ],
          },
        ],
      },
      {
        sectionCode: 'complementaryInfo',
        sectionTitle: 'Información complementaria',
        visibleStates: [],
        subsections: [
          {
            subsectionCode: 'deviceInfo',
            subsectionTitle: 'Información del dispositivo',
            visibleStates: [],
            elements: [
              {
                elementTypeName: 'FIELD',
                elementCode: 'deviceChallenge',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'deviceChallengeControl',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'signedChallenge',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'deviceId',
              },
            ],
          },
          {
            subsectionCode: 'sessionData',
            subsectionTitle: 'Información de la sesión',
            visibleStates: [],
            elements: [
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionCode',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionHandler',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionCipheredSignKey',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionCipheredEncryptKey',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionPublicData',
              },
            ],
          },
        ],
      },
      {
        sectionCode: 'loginControls',
        sectionTitle: 'Controles de acceso',
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        subsections: [
          {
            subsectionCode: 'loginActions',
            subsectionTitle: 'Acciones de ingreso',
            visibleStates: [
              'credentialInput',
              'complementaryInput',
              'sessionOpenning',
            ],
            elements: [
              {
                elementTypeName: 'ACTION',
                elementCode: 'openSession',
              },
              {
                elementTypeName: 'ACTION',
                elementCode: 'recoverPassword',
              },
            ],
          },
        ],
      },
    ],
    fields: [
      {
        fieldCode: 'userName',
        fieldTitle: 'Usuario',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        editableStates: [
          'credentialInput',
        ],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'credentialsInfo',
        subsectionCode: 'credentials',
      },
      {
        fieldCode: 'userPassword',
        fieldTitle: 'Contraseña',
        fieldTypeCode: 'TEXT',
        captureType: 'PASSWORD',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        editableStates: [
          'credentialInput',
        ],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'credentialsInfo',
        subsectionCode: 'credentials',
      },
      {
        fieldCode: 'deviceChallenge',
        fieldTitle: 'deviceChallenge',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'deviceInfo',
      },
      {
        fieldCode: 'deviceChallengeControl',
        fieldTitle: 'deviceChallengeControl',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'deviceInfo',
      },
      {
        fieldCode: 'signedChallenge',
        fieldTitle: 'signedChallenge',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'deviceInfo',
      },
      {
        fieldCode: 'sessionCode',
        fieldTitle: 'sessionCode',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'sessionData',
      },
      {
        fieldCode: 'sessionHandler',
        fieldTitle: 'sessionHandler',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'sessionData',
      },
      {
        fieldCode: 'sessionCipheredSignKey',
        fieldTitle: 'sessionCipheredSignKey',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'sessionData',
      },
      {
        fieldCode: 'sessionCipheredEncryptKey',
        fieldTitle: 'sessionCipheredEncryptKey',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'sessionData',
      },
      {
        fieldCode: 'sessionPublicData',
        fieldTitle: 'sessionPublicData',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'sessionData',
      },
      {
        fieldCode: 'deviceId',
        fieldTitle: 'deviceId',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'complementaryInfo',
        subsectionCode: 'deviceInfo',
      },
    ],
    actions: [
      {
        actionCode: 'openSession',
        actionTitle: 'Ingresar',
        visible: true,
        serverAction: true,
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        enabledStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'LOGIN',
        newState: 'sessionOpenning',
        sectionCode: 'loginControls',
        subsectionCode: 'loginActions',
      },
      {
        actionCode: 'recoverPassword',
        actionTitle: 'Recuperar contraseña',
        visible: true,
        serverAction: false,
        visibleStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        enabledStates: [
          'credentialInput',
          'complementaryInput',
          'sessionOpenning',
        ],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'PASSWORD',
        newState: '',
        sectionCode: 'loginControls',
        subsectionCode: 'loginActions',
      },
    ],
    tables: [],
  },
};